import UserEditComponent from "../MVPComponents/UserEditComponent";

const UserEdit = () => {
  return (
    <div>
      <UserEditComponent />
    </div>
  );
};

export default UserEdit;
